import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import AddQuestion from '../components/Public/Quiz/AddQuestion';
import QuizHighscore from '../components/Public/Quiz/QuizHighscore';
import QuizQuestions from '../components/Public/Quiz/QuizQuestions';
import { firestore } from '../firebase';
import StateContext from '../StateContext';

function SingleQuizPage() {

    const {id} = useParams();

    const appState = useContext(StateContext)

    const [quiz, setQuiz] = useState();
    const [show, setShow] = useState(false);

    const [activeItem, setActiveItem] = useState("1");

    useEffect(() => {

        try {
            const quizRef = firestore.collection("quiz").doc(id);

            quizRef.onSnapshot(doc => {
                const quiz = {id: doc.id, ...doc.data()}
                setQuiz(quiz);
            });

        } catch (error) {
            
        }

    }, [id])

    function toggle() {
        if (show) {
            setShow(false);
        } else {
            setShow(true);
        }
    }

    function toggleTabs(tab) {
        if (activeItem !== tab) {
            setActiveItem(tab)
        }
    }

    return (
        <div className="container my-4">

            {appState.loggedIn && appState.isAdmin && (
                <div className="row">
                    <div className="col-6">
                        <button onClick={() => toggleTabs("1")} className="btn btn-block btn-primary">Quiz</button>
                    </div>
                    <div className="col-6">
                        <button onClick={() => toggleTabs("2")} className="btn btn-block btn-primary">Rediger</button>
                    </div>
                </div>
            )}

            <h2 className="my-3 font-weight-bold text-center">{quiz?.name}</h2>

            {activeItem === "1" && (
                <React.Fragment>
                    <QuizQuestions id={id} />
                    <h4 className="font-weight-bold text-center mt-5">Toppscore</h4>
                    <QuizHighscore quizId={id} />
                </React.Fragment>
            )}

            {activeItem === "2" && (
                <React.Fragment>
                    {appState.loggedIn && appState.isAdmin && (
                        <React.Fragment>
                            <button className="btn btn-block btn-success" onClick={toggle}>+ Legg til spørsmål</button>
                            {show && (
                                <React.Fragment>
                                    <h2>Legg til spørsmål</h2>
                                    <AddQuestion quizId={id} />
                                
                                </React.Fragment>
                            )}

                            <QuizQuestions id={id} mode="edit" />

                        </React.Fragment>
                    )}
                </React.Fragment>
            )}

        </div>
    )

}
export default SingleQuizPage